export const TOP_SLOT_PROVIDERS = {
  1: 'Wizard',
  2: 'Netent',
  3: 'RedTiger',
  4: 'Big Time Gaming',
  5: 'Pragmatic Play',
  6: 'Relax',
  7: 'IGT',
  8: 'ReelPlay',
  9: 'Spinberry',
  10: 'Wazdan',
  11: 'Hacksaw',
  12: 'Playson',
  13: 'Inspired',
  14: 'No Limit City',
  15: 'Play N Go',
  16: 'Slingo',
  17: 'Quickspin',
  18: 'Everi',
  19: 'Eyecon',
  20: 'Blueprint',
  21: 'RAW Gaming',
  22: 'High 5 Games',
  23: 'Gamomat',
  24: 'Oryx',
  27: 'Indigo Magic',
  28: 'Skywind',
  29: 'Slotmill',
  30: 'Wild Streak Gaming',
  31: 'Skillz Gaming',
  33: 'Stakelogic',
  34: 'Fantasma Games',
  35: 'Swintt',
  36: '4 The Player',
  37: 'Print Studios',
  38: 'Peter & Sons',
  39: 'Storm Gaming',
  40: 'Jade Rabbit',
  32: 'Spin Games',
  41: 'Games Global',
  42: 'Blue Guru Games',
  43: 'Golden Rock',
  44: 'Four Leaf Gaming',
  45: 'Avatar UX',
  46: 'Silverback Gaming',
  47: 'Backseat Gaming',
  48: 'Bullshark Gaming',
  49: 'NowNow Gaming',
  50: 'Trusty Gaming',
  51: 'Kitsune Studios',
  52: 'Light And Wonder',
  53: 'AGS',
  54: '1x2 Network',
  55: 'Bragg',
  56: 'Konami',
  57: 'Greentube',
  58: 'Red Rake',
  59: 'Thunderkick',
  60: 'ELK',
  61: 'Ace Roll',
  63: 'Aristocrat',
  64: 'DWG',
};
